import React from 'react';
import {
    Container, CardBody, Row, Col, Badge, Button, ButtonGroup, FormCheckbox
} from "shards-react";
import * as moment from 'moment-timezone';
import { withRouter } from 'react-router-dom';
import { getColorMatch } from '../../utils/colors';

class JobTable extends React.Component {
    state = {
        selected: []
    }

    componentDidUpdate(props) {
        if (this.props.refresh && this.props.refresh !== props.refresh) {
            this.setState({ selected: [] })
        }
    }

    renderState(state) {
        if (state) {
            switch (state) {
                case 'assigned_to_agent':
                    return <Badge theme="info" className='mr-2'>{state.replace(/_/g, ' ')}</Badge>
                case 'in_hand_by_agent':
                    return <Badge theme="warning" className='mr-2'>{state.replace(/_/g, ' ')}</Badge>
                case 'awaiting_parts':
                case 'awaiting_parts_not_ordered':
                case 'awaiting_parts_ordered':
                case 'awaiting_parts_refer_to_defy':
                case 'refer_to_defy':
                    return <Badge theme="secondary" className='mr-2'>{state.replace(/_/g, ' ')}</Badge>
                case 'completed':
                    return <Badge theme="success" className='mr-2'>{state.replace(/_/g, ' ')}</Badge>
                default:
                    return <Badge theme="light" className='mr-2'>{state.replace(/_/g, ' ')}</Badge>
            }
        } return undefined
    }

    renderOrigin(origin) {
        switch (origin) {
            case 'walk_in':
                return <Badge theme="danger" className='mr-2' style={{ background: '#A9B0BC', fontSize: '8px' }}>Walk In</Badge>
            default:
                return <Badge theme="light" className='mr-2' style={{ fontSize: '8px' }}>Referral</Badge>
        }
    }

    renderPriority(priority) {
        switch (priority) {
            case 'urgent':
                return <Badge theme="danger">{priority}</Badge>
            case 'high':
                return <Badge>{priority}</Badge>
            case 'medium':
                return <Badge theme="warning">{priority}</Badge>
            default:
                return <Badge theme="light">{priority}</Badge>
        }
    }

    render() {
        const page = this.props.page
        const multiplier = this.props.count < 12 ? this.props.count : 12
        const max = this.props.count < page * multiplier ? this.props.count : page * multiplier

        if (this.props.data && this.props.data.length === 0) {
            return (
                <Container fluid className="main-content-container px-4 pb-4 job-table">
                    <div className="error__content mt-4">
                        <h2>Empty</h2>
                        <h3>No Service Calls Found</h3>
                        <p>It could be that there are no service calls or none for the filters selected </p>
                    </div>
                </Container>
            );
        }

        return (
            <CardBody className="p-0 pb-3 job-table " style={{ background: 'transparent' }}>
                {this.state.message && (
                    <Row className='py-3 px-4 mx-0' >
                        <div className="text-center text-danger">{this.state.message}</div>
                    </Row>
                )}
                {this.props.data.map((row, idx) => {
                    const selected = this.state.selected.filter(item => item.uuid === row['uuid']).length > 0
                    const customer = row['customer'] || {}
                    const customerFullName = customer['full_name'] || 'A'
                    const customerName = customerFullName.slice(0, 1).toLowerCase()
                    const colorMatch = getColorMatch(customerName)
                    var dueDate = 'Done'
                    if (row['due_in_days'] !== undefined) {
                        if (row['due_in_days'] > 0) {
                            dueDate = 'Due in ' + Math.abs(row['due_in_days']) + ' days'
                        } else if (row['due_in_days'] === 0) {
                            dueDate = 'Due Today'
                        } else {
                            dueDate = 'Due ' + Math.abs(row['due_in_days']) + ' days ago'
                        }
                    }

                    var appointmentDate = ''
                    if (row['appointment_at']) {
                        appointmentDate = moment(row['appointment_at']).tz('Africa/Johannesburg').calendar()
                    }

                    var serviceArea = ''
                    if (row['sponsor_area'] && row['service_area']) {
                        serviceArea = `${row['areas']['code']} - ${row['areas']['description']}`
                    }

                    const customerGram = (customerFullName || 'Customer').slice(0, 1)

                    return (
                        <div id={row['uuid']} key={row['uuid']}>
                            <Row className='job-list__item d-flex pr-2 pl-4 px-2 mx-0' >
                                <Col sm='0' md='0' lg='1' className='hide-on-tablet pl-2'>
                                    <div
                                        className='job-list__avatar mx-3 my-3'
                                        style={{ borderColor: colorMatch.dark, backgroundColor: colorMatch.light }}
                                        onClick={() => this.props.history.push('/jobs/details', {
                                            row: row,
                                            currentState: this.props.currentState,
                                            scroll: row['uuid']
                                        })}
                                    >
                                        <span className='job-list__avatar-content' style={{ color: colorMatch.dark }}>{customerGram}</span>
                                    </div>
                                </Col>
                                <Col sm='11' md='7' lg='7' className='py-2 px-0'>
                                    <div
                                        onClick={() => this.props.history.push('/jobs/details', {
                                            row: row,
                                            currentState: this.props.currentState,
                                            scroll: row['uuid']
                                        })}
                                    >
                                        <div className='d-flex-to-block text-uppercase'>
                                            <Badge theme="light" className='mr-2'>JOB NO. {row['job_no']}</Badge>
                                            {row['invoice_no'] && <Badge theme="light" className='mr-2'>INVOICE {row['invoice_no']}</Badge>}
                                            <div>
                                                {this.renderState(row['state'])}
                                                {(row['state'] !== 'completed') && this.renderPriority(row['priority'])}
                                            </div>
                                        </div>
                                        <h6 className='job-title my-2'>{row['model'] || 'Unknown Model'}</h6>
                                        <div className='my-1' style={{}}>
                                            <div
                                                className='d-inline-block item-icon-wrapper custom-nav-icon'
                                                dangerouslySetInnerHTML={{ __html: '<i class="material-icons">notes</i>' }}
                                            />
                                            <span>{row['issue']}</span>
                                        </div>
                                        <div className='my-1' style={{}}>
                                            <div
                                                className='d-inline-block item-icon-wrapper custom-nav-icon'
                                                dangerouslySetInnerHTML={{ __html: '<i class="material-icons">location_on</i>' }}
                                            />
                                            <span style={{ textTransform: 'capitalize' }}>{customer['address']}</span>
                                        </div>

                                        {this.renderOrigin(row['job_origin'])}
                                        <span>&nbsp;{row['customer'] ? row['customer']['full_name'] : ''}</span>
                                        <span>{' • '} {customer['contact_mobile'] || customer['contact_home'] || customer['contact_work']}</span>
                                        <span>{' • '} {moment(row['called_at']).fromNow()}</span>
                                    </div>
                                </Col>
                                <Col sm='12' md='4' lg='4'>
                                    <div
                                        onClick={() => this.props.history.push('/jobs/details', {
                                            row: row,
                                            currentState: this.props.currentState,
                                            scroll: row['uuid']
                                        })}
                                    >
                                        <div className='d-flex my-2'>
                                            <div
                                                className='d-inline-block item-icon-wrapper custom-nav-icon bolder'
                                                style={{ fontWeight: 600 }}
                                                dangerouslySetInnerHTML={{ __html: '<i class="material-icons">alarm</i>' }}
                                            />
                                            <span style={{ textTransform: 'uppercase', fontWeight: 600 }}>{dueDate}</span>
                                        </div>
                                        <div className='d-flex my-2 text-uppercase'>
                                            <div
                                                className='d-inline-block item-icon-wrapper custom-nav-icon'
                                                dangerouslySetInnerHTML={{ __html: '<i class="material-icons">location_on</i>' }}
                                            />
                                            <span style={{ textTransform: 'capitalize' }}>{serviceArea}</span>
                                        </div>
                                        <div className='d-flex my-2 text-uppercase'>
                                            <div
                                                className='d-inline-block item-icon-wrapper custom-nav-icon'
                                                dangerouslySetInnerHTML={{ __html: '<i class="material-icons">event_available</i>' }}
                                            />
                                            <span style={{ textTransform: 'capitalize' }}>{appointmentDate}</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )
                })
                }
                <div className='bg-light d-flex text-center mt-2 px-3' style={{ width: '100%', height: '2rem', display: 'none' }}>
                    <div className='mx-2'>
                        <p align="center" valign="center" style={{ lineHeight: '2rem' }}>
                            Displaying {((page - 1) * 12) + 1} to {max} {this.props.count ? ` of ${this.props.count} ` : ''} results
                        </p>
                    </div>
                    <ButtonGroup className="mr-2 ">
                        {(page > 1) && <Button theme='secondary' type='button' onClick={() => this.props.onPrev()}>Prev</Button>}
                        <div style={{ width: '8px' }} />
                        {(this.props.count >= page * 12) && <Button theme='secondary' type='button' onClick={() => this.props.onNext()}>Next</Button>}
                    </ButtonGroup>
                </div>
            </CardBody >
        )
    }
}

export default withRouter(JobTable)
